<template>
  <div :class="getBannerContainerClass" v-if="cellList.length" id="big-banner-swiper" ref="bigBannerContainer">
    <swiper :options="swiperOption" ref="bigbanner" @click.native="goDetail()">
      <swiper-slide v-for="(cell, index) in cellList" :key="genTime + index">
        <MultiBannerItem :bannerInfo="cell"></MultiBannerItem>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { get } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import { AnalizeService, EventService } from '@/common/api/api.service'
import MultiBannerItem from './banner/MultiBannerItem'
import EventModelClass from '@/common/model/EventModelClass'
import { bannerLink } from '@/common/util/common'
export default {
  name: 'Banner1',
  components: {
    MultiBannerItem: MultiBannerItem
  },
  data () {
    return {
      cellList: [],
      genTime: '',
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        autoplayDisableOnInteraction: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        loop: true,
        centeredSlides: true
      }
    }
  },
  props: ['sectionInfo'],
  computed: {
    getBannerContainerClass () {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      if (w > 767) {
        return 'multi-banner-container split-banner'
      } else {
        return 'multi-banner-container'
      }
    }
  },
  methods: {
    resize () {
      const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      if (w > 767) {
        this.$refs.bigBannerContainer.classList && this.$refs.bigBannerContainer.classList.add('split-banner')
      } else {
        this.$refs.bigBannerContainer.classList && this.$refs.bigBannerContainer.classList.remove('split-banner')
      }
    },
    goDetail () {
      const bannerIndex = this.$refs.bigbanner.swiper.clickedSlide.dataset.swiperSlideIndex
      const { onNavigationEvent, onClickEvent } = getEventListByType(this.cellList[bannerIndex].event_list)
      if (onClickEvent) {
        AnalizeService.sendLogList([onClickEvent]).then(() => {
          bannerLink(onNavigationEvent.url)
        })
      } else {
        bannerLink(onNavigationEvent.url)
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
    // setTimeout(() => {
    //   this.resize()
    // }, 500)
  },
  created () {
    EventService.requestEventData(new EventModelClass(this.sectionInfo.contentEvent)).then(({ data }) => {
      this.genTime = get(data, 'gen_time', '')
      this.cellList = get(data, ['band', 'celllist'], [])
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
  }
}
</script>

<style scoped>
  .multi-banner-container {
    width: 100%;
  }
  .split-banner .swiper-slide {
    width: 40% !important;
  }
  /*.swiper-slide.swiper-slide-active {*/
    /*width: 400px !important;*/
  /*}*/
</style>
